import { create } from "zustand";

interface MainBannerStore {
  height: number;
  setHeight: (height: number) => void;
}

export const useMainBannerStore = create<MainBannerStore>()((set) => ({
  height: 0,
  setHeight: (height) => set({ height })
}));
